import React, { Fragment, useState,useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import {
  AfterNo,
  BeforeNo,
  Dash,
  DateFive,
  DateFormate,
  DateFour,
  DateOne,
  DateSix,
  DateThree,
  DateTwo,
  Decimal,
  Dot,
  FinancialYearStart,
  Next,
  PerPosition,
  Separator,
  TimeZone,
} from "../../../../Constant";
import Typeahead from "../../../../CommonElements/TypeAhead/index";
import { useSelector } from "react-redux";
import { getClientUrlDataToken } from "../../../../Utils/restUtils";
import { getTimezoneSelect } from "../../../../CommonUrl";

const monthOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

const getFinancialMonth = (financial) => {
  if (!financial) return { value: "January", label: "January" };
  if (financial.value) return financial;

  const selectedMonth = monthOptions.find(
    (month) => month.value === financial || month.label === financial
  );
  if (selectedMonth) return selectedMonth;

  const financialDate = new Date(financial);
  if (!Number.isNaN(financialDate.getTime())) {
    return monthOptions[financialDate.getMonth()];
  }

  return { value: "January", label: "January" };
};

const Formstep2 = ({ setSteps, setFormdata, formdata }) => {
  const {
    handleSubmit,
    control,
    setValue,
  } = useForm();
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const authState = useSelector((state) => state.auth);

  const timezoneApi = async () => {
    const data = await getClientUrlDataToken(authState.apiUrl, getTimezoneSelect);
    if (data.status === true) {
      const transformedData = data.data.map((item) => ({
        label: item.label,
        value: item.name,
      }));
      setTimezoneOptions(transformedData);
    }
  };

  const dateFormat = [
    { value: "d M Y", label: DateOne },
    { value: "M d Y", label: DateTwo },
    { value: "Y M d", label: DateThree },
    { value: "d m Y", label: DateFour },
    { value: "m d Y", label: DateFive },
    { value: "Y m d", label: DateSix },
]


  const decimaloptions = [
    { value: "2", label: "0.00" },
    { value: "3", label: "0.000" },
    { value: "4", label: "0.0000" },
  ]



  
  const dateSeperator = [
        { value: "-", label: Dash },
        // { value: "/", label: Slash },
        { value: ".", label: Dot },
        // { value: ",", label: Comma },
        // { value: " ", label: Space }
    ];
  const percentPosition = [
    { value: "after", label: AfterNo },
    { value: "before", label: BeforeNo },
  ]

  useEffect(() => {
    timezoneApi();
    setValue("time", {
      value: formdata?.time?.value,
      label: formdata?.time?.label,
    });
  }, []);


  const onSubmit = (data) => {
    if (data) {
      setFormdata((prev) => ({ ...prev, ...data }));
      setSteps((pre) => pre + 1);
    }
  };
  return (
    <Fragment>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-bookmark needs-validation"
      >
        <Row className="g-3 pt-3">
          <Col md="6">
            <FormGroup className="mb-3">
              <Label htmlFor="financial">{FinancialYearStart}</Label>
              <Controller
                name="financial"
                control={control}
                defaultValue={getFinancialMonth(formdata.financial)}
                render={({ field }) => (
                  <Typeahead
                    id="financial"
                    options={monthOptions}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}
                  />
                )}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup className="mb-3">
              <Label>{TimeZone}</Label>
              <Controller
                name="timezone"
                control={control}
                defaultValue={formdata.timezone || ""}
                render={({ field }) => (
                  <Typeahead
                    options={timezoneOptions}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}

                  />
                )}
              />

            </FormGroup>
          </Col>
        </Row>
        <Row className="g-3">
          <Col md="6">
            <FormGroup className="mb-3">
              <Label >{DateFormate}</Label>
              <Controller
                name="dateFormate"
                control={control}
                defaultValue={formdata.dateFormate || ""}

                render={({ field }) => (
                  <Typeahead
                    options={dateFormat}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}

                  />
                )}
              />

            </FormGroup>
          </Col>
          <Col md="6">
            <Label >{Separator}</Label>
            <Controller
              name="separator"
              control={control}
              defaultValue={formdata.separator || ""}

              render={({ field }) => (
                <Typeahead
                  options={dateSeperator}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>
        </Row>
        <Row className="g-3 ">
          <Col md="6">
            <Label >{PerPosition}</Label>
            <Controller
              name="position"
              control={control}
              defaultValue={formdata.position || ""}

              render={({ field }) => (
                <Typeahead
                  options={percentPosition}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>
          <Col md="6">
            <Label >{Decimal}</Label>
            <Controller
              name="decimal"
              control={control}
              defaultValue={formdata.decimal || decimaloptions[0]}
              render={({ field }) => (
                <Typeahead
                  options={decimaloptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>


        </Row>
        <div className="text-end">
          <Btn attrBtn={{ color: "primary", type: "submit", id: "submit-step-2" }}>{Next}</Btn>
        </div>
      </Form>
    </Fragment>
  );
};

export default Formstep2;
